<template>
  <div>
    <h3 class="text-lg leading-loose">
      <label for="gd">
        <input disabled id="gd" type="checkbox" v-model="form.enable" /> Global
      </label>
    </h3>

    <div v-if="form.enable" class="bg-white rounded shadow">
      <div class="p-3 mb-3">
        <div class="mb-5">
          <h2 class="text-gray-600 font-bold mb-4">Applicable on</h2>
          <!--Eligible Criteria -->
          <div class="flex items-center gap-x-5">
            <div>
              <label>
                <input v-model="form.applicable_type" @input="onApplicableTypeValueChanges" name="criteria" value="every_order" type="radio" /> Every order
              </label>
            </div>
            <div>
              <label>
                <input v-model="form.applicable_type" @input="onApplicableTypeValueChanges" name="criteria" value="by_value" type="radio" /> By Value
              </label>
            </div>
          </div>
          <div class="mt-3">
            <label for="amount">Amount Greater than</label>
            <input
              id="amount"
              :disabled="form.applicable_type !== 'by_value'"
              v-model.number="form.amount_gt"
              type="number" class="mt-1 py-2 px-2 rounded border"
              ref="amountInput"
            />
          </div>
          <div class="mt-8">
            <label>
              <input v-model="form.per_customer" name="criteria" value="one_order_per_customer" type="checkbox" /> Per Order per Customer
            </label>
          </div>

          <!--Eligible Item -->
          <div class="mt-4 bg-white rounded shadow">
            <div class="space-y-8 divide-y divide-gray-200">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Item Code</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Free Qty</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Qty</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Qty Used</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">UOM</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <AddFreeItemModal
                        v-slot="{open}"
                        :applicable-type="form.applicable_type"
                        :unlimited="form.unlimited"
                        @add="addDiscountRuleAction"
                        :rules="form.rules"
                      >
                        <button type="button" class="bg-primary-500 px-4 py-2 text-white" @click="open">+ Add Item</button>
                      </AddFreeItemModal>
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-if="form.rules && form.rules.length === 0">
                    <td colspan="6" class="px-8 py-4 text-center whitespace-nowrap text-sm font-medium text-gray-900">No item(s)</td>
                  </tr>
                  <tr v-for="(rule, index) in form.rules" :key="'rule-'+index">
                    <td class="px-8 py-4 text-sm font-medium text-gray-900">
                      {{ rule.free_item.desc }}
                      <div class="text-sm text-gray-400">{{ rule.free_item.item_code }}</div>
                    </td>
                    <td class="whitespace-nowrap text-sm font-medium text-gray-900 px-4">
                      <input
                        type="number" v-model.number="rule.free_item_qty"
                        placeholder="Free Qty"
                        required
                        class="border px-3 py-3 w-20" />
                    </td>
                    <td class="px-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      <div v-if="rule.unlimited">Unlimited</div>
                      <input
                        v-else
                        type="number" v-model.number="rule.total_qty"
                        placeholder="Total Qty"
                        required
                        class="border px-3 py-3 w-20" />
                    </td>
                    <td class="px-4 text-center whitespace-nowrap text-sm font-medium text-gray-900">
                      <template v-if="usages && Object.keys(usages).length">
                        {{ usages[rule.free_item.item_code] || 0 }}
                      </template>
                      <template v-else>0</template>

                    </td>
                    <td class="px-8 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      <div>{{ rule.free_item_unit || 'n/a' }}</div>
                    </td>
                    <td class="text-right px-4 flex justify-end items-center py-2">
                      <button class="block rounded bg-red-500 text-white p-2 hover:red-900" @click.prevent="removeRule(rule)"><Icon name="trash" class="h-4 w-4 fill-current"/></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "../../../../Shared/Icon.vue";
import vSelect from 'vue-select'
import Modal from "../../../../Shared/Modal.vue";
import AddFreeItemModal from "./AddFreeItemModal.vue";

export default {
  name: 'GlobalOfferAction',
  components: {AddFreeItemModal, Modal, Icon, vSelect},

  props: {
    value: {
      type: Object,
    },
    usages: [Object,Array],
  },

  data() {
    return {
      discountRule: {
        itemCodeUnits: [],
        selectableItems: [],
        action: {
          amount_gt: 0,
          free_item: null,
          free_item_qty: null,
          free_item_unit: null,
          total_qty: null,
        }
      },
      form: this.value
    }
  },

  methods: {
      removeRule(rule) {
        this.form.rules.splice(this.form.rules.indexOf(rule), 1)
      },

    addDiscountRuleAction(ruleAction) {
      // Extract item code from the rule action
      let itemCode = ruleAction.free_item.item_code;

      // Check if the item code already exists in the form.rules array
      let itemExists = this.form.rules.some(rule => rule.free_item.item_code === itemCode);

      // If item code doesn't exist, add it to the form.rules array
      if (!itemExists) {
        this.form.rules.push(ruleAction);
      }
    },

    onApplicableTypeValueChanges(e) {
      const val = e.target.value
      if (val === 'every_order') {
        this.form.amount_gt = null
      } else {
          this.form.amount_gt = 0
          setTimeout(() => {
            this.$refs.amountInput.focus();
          }, 10)
      }
    }
  }
}
</script>
